import { useState } from "react";
import { useLocalization } from "../../hooks/use-localization/useLocalization";
import { useNetwork } from "../../hooks/useNetwork/useNetwork";
import { StatusMessage } from "../status-message/statusMessage";

export const Logout: React.FC<{ onLogout: () => any }> = ({ onLogout }) => {
  const { localize, localizeString } = useLocalization();
  const { network, loading } = useNetwork();
  const [error, setError] = useState<string>("");

  return (
    <>
      <button
        className="secondary"
        disabled={loading}
        onClick={async () => {
          try {
            await network("/logout", { method: "POST" });
            onLogout();
          } catch (error) {
            console.error(error);
            setError("error:logoutFailed");
          }
        }}
      >
        {loading ? localize("loading") : localize("logout")}
      </button>
      {error && (
        <StatusMessage type="error">{localizeString(error)}</StatusMessage>
      )}
    </>
  );
};
